<template>
  <div id="bdm_management" :class="isFull === 1 ? 'bdm_management top_information1' : ' bdm_management'">
    <van-nav-bar :title="$t('column.host_management')" placeholder fixed left-arrow >
        <template #left>
            <img src="../assets/img/bdm/bdm_left.png" alt="" height="20vw" @click="onClickLeft">
        </template>
        <template #right>
            <img src="../assets/img/bdm/equip_noble_ic_entry_worship.png" alt="" height="20vw" @click="onClickRank">
        </template>
    </van-nav-bar>
    <van-row>
      <!--  搜索    -->
      <van-col span="22" offset="1" class="search-section">
        <!-- 第一行：Total Adm, 搜索框, Query按钮 -->
        <van-row type="flex" justify="space-between" align="center" class="search-row-1">
          <van-col class="total-adm">
            <van-row class="label">{{ $t('column.total') }} {{ permission_name }}</van-row>
            <van-row class="value">{{ total_number }}</van-row>
          </van-col>
          <van-col class="search-input-box">
            <van-field
              v-model="searchKeyword"
              left-icon="search"
              :placeholder="$t('column.search_user_id')"
              class="custom-search-field"
              clearable
            />
          </van-col>
          <van-col class="query-btn-box">
            <van-button class="query-btn" round type="primary" @click="onSearch">{{ $t('column.Query') }}</van-button>
          </van-col>
        </van-row>

        <!-- 第二行：Time 选择 -->
        <van-row type="flex" justify="center" align="center" class="search-row-2">
          <van-col class="time-label">{{ $t('other.time') }}:</van-col>
          <van-col class="date-picker-box" @click="showStartDatePicker = true">
            <img src="../assets/img/bdm/creator_agency_tab_date.png" class="calendar-icon"/>
            <span class="date-text">{{ startDate || $t('column.all') }}</span>
            <van-icon v-if="startDate" name="clear" class="arrow-icon" @click.stop="startDate = ''" />
            <van-icon v-else name="arrow-down" class="arrow-icon" />
          </van-col>
          <van-col class="date-separator">-</van-col>
          <van-col class="date-picker-box" @click="showEndDatePicker = true">
            <img src="../assets/img/bdm/creator_agency_tab_date.png" class="calendar-icon"/>
            <span class="date-text">{{ endDate || $t('column.all') }}</span>
            <van-icon v-if="endDate" name="clear" class="arrow-icon" @click.stop="endDate = ''" />
            <van-icon v-else name="arrow-down" class="arrow-icon" />
          </van-col>
        </van-row>
      </van-col>
      <!--  列表    -->
      <van-col span="24">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('other.there_is_no_more')"
          :loading-text="$t('other.Loading')"
          @load="onLoad"
        >
           <van-cell v-for="(item,i) in list" :key="i" class="custom-cell">
            <van-col span="24">
              <van-col span="24" class="card-item">
                <van-col class="join-date">{{ $t('column.join_date') }}: {{ item.join_time }}</van-col>
                <van-row type="flex" align="center" class="user-info">
                  <van-col class="avatar-box">
                    <img :src="item.head_image" class="avatar" />
                  </van-col>
                  <van-col class="user-details">
                    <van-row type="flex" align="center" class="name-row">
                      <span class="name">{{ item.nick_name }}</span>
                      <img :src="item.country_img" v-if="item.country_img"/>
                    </van-row>
                    <van-row class="id-row">ID:{{ item.user_id }}</van-row>
                  </van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="stats-box">
                  <van-col class="stat-item">
                    <van-row class="stat-title">{{ $t('column.total_host_earnings') }}</van-row>
                    <van-row type="flex" align="center" class="stat-value">
                      <img src="../assets/img/coin9.png" class="stat-icon"/>
                      <span>{{ item.total_coin }}</span>
                    </van-row>
                  </van-col>
                  <van-col class="stat-item">
                    <van-row class="stat-title">{{ $t('column.this_month_earnings') }}</van-row>
                    <van-row type="flex" align="center" class="stat-value">
                      <img src="../assets/img/coin9.png" class="stat-icon" />
                      <span>{{ item.month_coin }}</span>
                    </van-row>
                  </van-col>
                </van-row>
              </van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>

      <van-overlay :show="loading" z-index="2003">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>

      <!-- Date Pickers -->
      <van-popup v-model="showStartDatePicker" position="bottom">
        <van-datetime-picker
          v-model="currentStartDate"
          type="date"
           :max-date="maxDate"
          :title="$t('column.select_date')"
          @confirm="onConfirmStartDate"
          @cancel="showStartDatePicker = false"
        />
      </van-popup>

      <van-popup v-model="showEndDatePicker" position="bottom">
        <van-datetime-picker
          v-model="currentEndDate"
          type="date"
           :max-date="maxDate"
         :title="$t('column.select_date')"
          @confirm="onConfirmEndDate"
          @cancel="showEndDatePicker = false"
        />
      </van-popup>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'

export default {
  data:function() {
    return {
      searchKeyword: '',
      startDate: '',
      endDate: '',
      showStartDatePicker: false,
      showEndDatePicker: false,
      currentStartDate: new Date(),
      currentEndDate: new Date(),
      maxDate:new Date(),
      list: [],
      loading: false,
      finished: false,
      page: 1,
      permission_name: 'Host',
      total_number: 0,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏

    this.get_list()
  },
  methods: {
    onClickRank(){
      this.$router.push({ name: 'bdm_host_rank', query: { token: this.$route.query.token, is_full: this.isFull } })
    },
    onLoad() {
      if (this.page > 1){
        this.get_list()
      }
    },
    formatDate(date) {
      const d = new Date(date)
      const month = ('0' + (d.getMonth() + 1)).slice(-2)
      const day = ('0' + d.getDate()).slice(-2)
      const year = d.getFullYear()
      return `${month}-${day}-${year}`
    },
    onConfirmStartDate(value) {
      this.startDate = this.formatDate(value)
      this.showStartDatePicker = false
    },
    onConfirmEndDate(value) {
      this.endDate = this.formatDate(value)
      this.showEndDatePicker = false
    },
    onClickLeft() {
      // 返回上一页
      this.$router.go(-1)
    },
    Jump_intercept(item) {
      // 拦截返回app
      window.location.href="live://live?action=recharge&id="+ item.id
    },
    onSearch() {
      this.page = 1
      this.finished = false
      this.list = []
      this.get_list()
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      if (this.page === 1) {
        this.list = []
      }
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=host_management",{ 
        params:{
          token: token,
          to_uid: this.searchKeyword,
          start_date: this.startDate,
          end_date: this.endDate,
          page: this.page
        }
      }).then(res =>{
        console.log(res)
        // 加载状态结束
          this.loading = false
        if(res.data.status===1){
          for (let j = 0; j < res.data.data.list.length; j++) {
            this.list.push(res.data.data.list[j])
          }
          this.total_number =res.data.data.total_number
          //如果列表数据条数< 0，不再触发滚动加载
          if (res.data.data.list.length <= 0) {
            this.finished = true
          }
          this.page ++
        }else{
          // 数据全部加载完成
          this.finished = true
          Toast(res.data.error);
        }
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bdm_host_management.vue